<template>
    <form @submit.prevent="submitForm">
        <ValidationObserver v-slot="{ invalid, errors }">

            <ValidationProvider name="Email adres" rules="required|email" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-name" class="form-control-label">Email adres</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <icon name="inbox"></icon>
                        </span>
                        </div>
                        <input
                            type="text"
                            v-model="formValues.email"
                            class="form-control"
                            id="input-email"
                            placeholder="Vul uw e-mailadres in"
                            :class="{ 'is-invalid': errors.length }"
                            required />
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider name="Wachtwoord" rules="required" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-password" class="form-control-label">Wachtwoord</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <icon name="key"></icon>
                            </span>
                        </div>
                        <input
                            :type="passwordVisible ? 'text' : 'password'"
                            v-model="formValues.password"
                            class="form-control"
                            id="input-password"
                            placeholder="Vul uw wachtwoord in"
                            :class="{ 'is-invalid': errors.length }"
                            required
                        />
                        <div class="input-group-append">
                                <span class="input-group-text" @click="togglePassword" style="cursor: pointer;">
                                    <icon :name="passwordVisible ? 'eye-slash' : 'eye'" style="fill: black !important;"></icon>
                                </span>
                        </div>
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider name="Wachtwoord bevestiging" rules="required|confirmed:password" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-password-confirmation" class="form-control-label">Bevestig Wachtwoord</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <icon name="key"></icon>
                        </span>
                        </div>
                        <input
                            :type="passwordConfirmationVisible ? 'text' : 'password'"
                            v-model="formValues.password_confirmation"
                            class="form-control"
                            id="input-password-confirmation"
                            placeholder="Bevestig uw wachtwoord"
                            :class="{ 'is-invalid': errors.length }"
                            required
                        />
                        <div class="input-group-append">
                                <span class="input-group-text" @click="togglePasswordConfirmation" style="cursor: pointer;">
                                    <icon :name="passwordConfirmationVisible ? 'eye-slash' : 'eye'" style="fill: black !important;"></icon>
                                </span>
                        </div>
                        <div v-if="errors.length" class="invalid-feedback" style="display: block !important;">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

        </ValidationObserver>
    </form>
</template>

<script>

    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: 'ResetPasswordForm',

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        props: {
            initialValues: {
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                formValues: this.initialValues ? { ...this.initialValues } : {
                    email: '',
                    password: '',
                    password_confirmation: '',
                },
                passwordVisible: false,
                passwordConfirmationVisible: false,
            };
        },
        methods: {
            togglePassword() {
                this.passwordVisible = !this.passwordVisible;
            },
            togglePasswordConfirmation() {
                this.passwordConfirmationVisible = !this.passwordConfirmationVisible;
            },
            submitForm() {
                this.$emit('submit', this.formValues);
            },
        },
    };
</script>
